import { registerArchetype } from './index.js';
import { applyDamage, computeDamage, lowestHpEnemy, livingEnemies, enemySide, getRuntimes, effectiveAtk, effectiveDef } from '../combat.js';
registerArchetype({
    id: 'drain',
    apply: ({ state, source, params, rng }) => {
        const mult = params.multiplier ?? 1;
        const atkReduction = params.atkReduction ?? 0.2;
        const duration = params.duration ?? 4;
        const enemies = livingEnemies(state, source.side);
        if (enemies.length === 0)
            return;
        const target = lowestHpEnemy(state, source.side);
        const sourceRt = (source.side === 'A' ? state.sideA : state.sideB)[source.slot];
        const dmg = computeDamage(effectiveAtk(sourceRt) * mult, effectiveDef(target.runtime));
        const enemyKey = enemySide(source.side);
        applyDamage(state, source, { side: enemyKey, slot: target.slot }, dmg, false, rng);
        if (target.runtime.alive) {
            getRuntimes(state, enemyKey)[target.slot].statuses.push({
                id: `drain_${state.tick}_${target.slot}`,
                kind: 'debuff', remainingTicks: duration, params: { atk: atkReduction }
            });
        }
    }
});
